import i18n from './i18nHelpers'

export default {
  getUserRewardStatus (userReward) {
    const rewardStatus = {
      cssClass: 'badge-received-reward',
      text: i18n.t('message.rewards.received_reward')
    }

    if (userReward.is_used) {
      rewardStatus.cssClass = 'badge-expired-received-reward'
      rewardStatus.text = i18n.t('message.rewards.used_reward')
    } else {
      if (userReward.is_expired) {
        rewardStatus.cssClass = 'badge-expired-received-reward'
        rewardStatus.text = i18n.t('message.rewards.expired')
      } else if (userReward.is_sent === 0) {
        if (!userReward.delivery_info) {
          rewardStatus.cssClass = 'badge-no-delivery-info'
          rewardStatus.text = i18n.t('message.rewards.waiting_for_delivery_info')
        } else {
          rewardStatus.cssClass = 'badge-waiting-delivery'
          rewardStatus.text = i18n.t('message.rewards.waiting_for_delivery')
        }
        if (userReward.wogi_order_id) {
          if (userReward.wogi_order_status === 'pending') {
            rewardStatus.cssClass = 'badge-waiting-delivery'
            rewardStatus.text = i18n.t('message.rewards.waiting_for_processing')
          } else if (userReward.wogi_order_status === 'failed') {
            rewardStatus.cssClass = 'badge-failed'
            rewardStatus.text = i18n.t('message.rewards.failed')
          }
        }
      } else if (userReward.is_sent === 1) {
        // rewardStatus.text = i18n.t('message.rewards.delivered')
        rewardStatus.text = i18n.t('message.rewards.received_reward')
      }
    }
    return rewardStatus
  }
}



// WEBPACK FOOTER //
// ./src/helpers/userRewardHelpers.js